export const config = {
  qrCodeDomains: [
    "http://localhost:3000",
    "https://experiences.dev.merchtablet-irobot.com",
    "https://experiences.stage.merchtablet-irobot.com",
    "https://experiences.merchtablet-irobot.com",
  ],
};

export default config;
